export default {
  en: {
    'pages.creditNote.title': 'Credit note',
    'pages.creditNote.title.heading': 'Do you have separate tax codes for credit notes?',
    'pages.creditNote.description': 'Corrections, refunds or returns on the transaction.',
    'pages.creditNote.yes': 'Yes',
    'pages.creditNote.no': 'No',
    'pages.creditNote.next': 'Next',
  },
};
